import React from 'react';
import { InboxMessagesContext, InboxMessageContextData } from 'src/providers';

export const useInboxMessagesCount = (): InboxMessageContextData => {
  return React.useContext(InboxMessagesContext);
};
